import zod from 'zod';
import { zodPage, zodLimit, stringToListOfNumber } from './helpers';
import { defaultPermissionsValue } from '../pages/access/PermissionLevels/PermissionLevelForm';


export const groupPermissionKeys = Object.keys(defaultPermissionsValue) as [
    keyof GroupPermissions,
    ...(keyof GroupPermissions)[]
];

export const permissionKeys = Object.keys(defaultPermissionsValue) as [
    keyof UserPermissions,
    ...(keyof UserPermissions)[]
];

const WorkSchedulesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

const SkillsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

const SupportTicketsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

const InstallationCompaniesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

const InternetCompaniesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

const TurnstilesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

const PlatformSettingsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

const AbuseReportsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
});

const UserTagsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

const HolidaysSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    year: zod.coerce.number().optional(),
});

const PermissionLevelsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyUnitIds: stringToListOfNumber.optional(),
    userId: zod.coerce.number().optional(),
    permissions: zod.array(zod.enum(permissionKeys)).optional(),
    roleId: zod.coerce.number().optional(),
    patent: zod.string().optional(),
    agentScheduleId: zod.coerce.number().optional(),
    userTagId: zod.coerce.number().optional()
});

const PermissionLevelFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

const SupportTicketDetailSchema = zod.object({
    id: zod.coerce.number(),
});

const GroupsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyUnitIds: stringToListOfNumber.optional(),
    userId: zod.coerce.number().optional(),
    cameraId: zod.string().optional(),
    groupPermissions: zod.array(zod.enum(groupPermissionKeys)).optional(),
    roleId: zod.coerce.number().optional(),
    patent: zod.string().optional(),
    agentScheduleId: zod.coerce.number().optional(),
    userTagId: zod.coerce.number().optional(),
});

const GroupFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

const UsersSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
    actingBodyUnitId: zod.coerce.number().optional(),
    role: zod.coerce.number().optional(),
    phone: zod.string().optional(),
    document: zod.string().optional(),
    userBlockNature: zod.string().optional(),
});

const UserFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

const AllowedIpsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

const ActingBodiesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
});

const ActingBodyFormSchema = zod.object({
    id: zod.coerce.number().optional(),
}).optional();

const ActingBodyUnitsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

const ActingBodyCommandsSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

const RolesSchema = zod.object({
    page: zodPage,
    limit: zodLimit(),
    textFilter: zod.string().optional(),
    actingBodyId: zod.coerce.number().optional(),
});

export const AccessSchemas = {
    Skills: SkillsSchema,
    Users: UsersSchema,
    UserForm: UserFormSchema,
    PermissionLevels: PermissionLevelsSchema,
    PermissionLevelForm: PermissionLevelFormSchema,
    Turnstiles: TurnstilesSchema,
    Groups: GroupsSchema,
    GroupForm: GroupFormSchema,
    InstallationCompanies: InstallationCompaniesSchema,
    InternetCompanies: InternetCompaniesSchema,
    ActingBodies: ActingBodiesSchema,
    ActingBodiesForm: ActingBodyFormSchema,
    ActingBodyUnits: ActingBodyUnitsSchema,
    ActingBodyCommands: ActingBodyCommandsSchema,
    Roles: RolesSchema,
    AllowedIps: AllowedIpsSchema,
    PlatformSettings: PlatformSettingsSchema,
    UserTags: UserTagsSchema,
    PtzPriority: zod.object({}),
    AbuseReports: AbuseReportsSchema,
    WorkSchedules: WorkSchedulesSchema,
    Holidays: HolidaysSchema,
    SupportTickets: SupportTicketsSchema,
    SupportTicketDetail: SupportTicketDetailSchema
};
